import React, { FC } from 'react';
import styled from 'styled-components';

const Line = styled.span`
    border-radius: 3px;

    @keyframes progress {
        0% {
            left: -600px;
        }
        100% {
            left: 100%;
        }
    }

    &.skeleton-loader {
        line-height: 1;
        display: inline-block;
        overflow: hidden;
        position: relative;
    }

    &.skeleton-loader::before {
        content: '';
        position: absolute;
        height: 100%;
        width: 600px;
        top: 0;
        left: -600px;
        background-image: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.6),
            rgba(255, 255, 255, 0)
        );
        animation: progress 1.3s ease-in-out infinite;
    }
`;

interface SkeletonProps {
    width: string;
    height: string;
    color: string;
    count: number;
    dinamicWidth?: boolean;
}

const Skeleton: FC<SkeletonProps> = ({
    width,
    height,
    color,
    count,
    dinamicWidth = true,
}) => {
    const w = parseFloat(width);
    const h = parseFloat(height);
    const wm = width.toString().replace(/\d+/g, '');
    const hm = height.toString().replace(/\d+/g, '');

    const els = [];

    for (let i = 0; i < count; i++) {
        const width = `${
            w - Math.random() * w * (dinamicWidth ? 0.05 : 0)
        }${wm}`;
        const height = `${h}${hm}`;

        els.push(
            <Line
                className={`skeleton-loader animated`}
                key={i}
                style={{
                    width,
                    height,
                    backgroundColor: color,
                }}
            >
                &zwnj;
            </Line>
        );
    }

    return <div>{els}</div>;
};

export { Skeleton };
